import {
  useEffect,
  useRef,
  useState
} from 'react'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import {
  getNotificationMessage,
  usersSelectors
} from 'store'
import {
  Box,
  Input,
  Stack,
  Text
} from '@chakra-ui/react'
import { isMobile } from 'utils/helpers'
import { COLORS } from 'utils/styles'
import { REJECTED } from 'utils/constants'

export const Affinities = ({
  affinitiesArray,
  setAffinitiesArray
}) => {
  const dispatch = useDispatch()
  const { searchBar } = useSelector(usersSelectors)
  const [affinitiesInput, setAffinitiesInput] = useState('')
  const affinitiesListRef = useRef(null)
  const inputRef = useRef(null)

  const filterAffinityList = (
    affinities = searchBar?.affinities
  ) => {
    if (affinitiesArray.length) {
      const selectedAffIds = affinitiesArray.map((aff) => aff.id)
      affinities = affinities.filter((aff) => !selectedAffIds.includes(aff.id))

      console.log('selectedAffIds', selectedAffIds)
      console.log('affinities', affinities)
    }

    return affinities?.map((item) => {
      const highlightPart = () => {
        const lowerTitle = item?.title.toLowerCase()
        const lowerSearch = affinitiesInput.toLowerCase()

        const matchIndex = lowerTitle.indexOf(lowerSearch)
        const matchedText = item?.title.slice(matchIndex, matchIndex + affinitiesInput.length)

        return (
          <Text cursor="pointer">
            {item?.title.slice(0, matchIndex)}
            <Text as="span" fontWeight="bold">{matchedText}</Text>
            {item?.title.slice(matchIndex + affinitiesInput.length)}
          </Text>
        )
      }

      return (
        <Box
          onClick={() => {
            if (affinitiesArray.length < 3) {
              setAffinitiesArray([...affinitiesArray, { id: item.id, title: item.title }])
              setAffinitiesInput('')
            } else {
              dispatch(
                getNotificationMessage({
                  type: REJECTED,
                  message: 'Maximum of 3 affinities only',
                  isEditProfile: true
                })
              )
            }
          }}
          p="3px 6px"
          cursor="pointer"
          borderRadius="5px"
          bg={COLORS.gold}
          width="max-content"
          alignItems="center"
          name={item.title}
          fontSize="13px"
        >
          {
            affinitiesInput
              ? highlightPart()
              : item.title
          }
        </Box>
      )
    })
  }

  const [filteredAffinityList, setFilteredAffinityList] = useState(filterAffinityList())

  useEffect(() => {
    let affinityListTemp = searchBar?.affinities
    const tempAffinitiesInput = affinitiesInput.toLowerCase()

    if (affinitiesInput !== '') {
      affinityListTemp = affinityListTemp.map((item) => {
        const title = item.title.toLowerCase()
        let score = 0

        if (title.startsWith(tempAffinitiesInput)) {
          score = 3
        } else if (title.endsWith(tempAffinitiesInput)) {
          score = 2
        } else if (title.includes(tempAffinitiesInput)) {
          score = 1
        }

        return {
          id: item?.id,
          title: item?.title,
          score
        }
      })
        .filter((item) => item.score > 0)
        .sort((a, b) => b.score - a.score)
    }

    setFilteredAffinityList(filterAffinityList(affinityListTemp))
  }, [affinitiesInput, affinitiesArray])

  return (
    <Stack
      overflow="hidden"
      direction="column"
      spacing="1rem 10px"
      position="absolute"
      width="100%"
      zIndex={2}
    >
      <Box
        display="flex"
        justifyContent="center"
      >
        <Input
          ref={inputRef}
          placeholder="Tag your article with one affinity"
          value={affinitiesInput}
          onChange={(e) => setAffinitiesInput(e.target.value)}
          name="profile_affinities"
          width="85%"
          height="35px"
          background={COLORS.lighterGray}
          borderBottomLeftRadius="none"
          borderBottomRightRadius="none"
        />
      </Box>

      <Box
        display="flex"
        justifyContent="center"
      >
        <Stack
          as="button"
          ref={affinitiesListRef}
          gap="10px"
          spacing="0px"
          direction="row"
          flexWrap="wrap"
          data-name="affinityList"
          maxHeight={isMobile() ? '13svh' : '10em'}
          width="85%"
          overflowY="scroll"
          background={COLORS.lighterGray}
          padding="5px"
          borderRadius="0 0 5px 5px"
          marginTop="-16px"
        >
          {
            filteredAffinityList?.length
              ? filteredAffinityList
              : <Text textAlign="center" width="100%">No results found</Text>
          }
        </Stack>
      </Box>
    </Stack>
  )
}
